import Vue from 'vue';
import VueRouter from 'vue-router';
import Job from '../components/Job.vue'
import Documents from '../components/Documents.vue'
import Protocol from '../components/Protocol.vue'
import Asset from '../components/Asset.vue'
import Login from '../components/login_portal/Login.vue'
import Customer from '../components/login_portal/Customer.vue'
import Project from '../components/login_portal/CustomerProjectDetails.vue'
import AssetDetails from '../components/login_portal/AssetDetails.vue'
import FormDetails from '../components/login_portal/FormDetails.vue'

Vue.use(VueRouter);

const routes = [
	{
		path: '/job',
		name: 'Job',
		props: true,
		component: Job
	},
	{
		path: '/documents',
		name: 'Documents',
		props: true,
		component: Documents
	},
	{
		path: '/protocol',
		name: 'Protocol',
		props: true,
		component: Protocol
	},
	{
		path: '/asset/',
		name: 'Asset',
		props: true,
		component: Asset
	},
	{
		path: '/',
		name: 'Login',
		props: true,
		component: Login
	},
	{
		path: '/customer/:id',
		name: 'Customer',
		props: true,
		component: Customer
	},
	{
		path: '/project/:id',
		name: 'Project',
		props: true,
		component: Project
	},
	{
		path: '/assetdetails/:id',
		name: 'AssetDetails',
		props: true,
		component: AssetDetails
	},
	{
		path: '/formdetails/:id',
		name: 'FormDetails',
		props: true,
		component: FormDetails
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
